<template>
  <div class="page-content">
    <h1 class="page-title">
      Wrong configurations <span v-if="meta.totalcount > 0">({{ meta.totalcount }})
      <action-button
        text="Reload"
        glyph="svg -reload"
        style="width: 130px; padding-top: 3px; float: right;"
        @pressed="initialFetch" >
      </action-button></span>
    </h1>
    <div class="container upper_header">
      <div class="flex-item">
        <SimplePagination :total="meta.totalcount || 0"
                          :page-index="pageIndex"
                          :page-size="pageSize"
                          @on-page-number-change="pageNumberChange"
                          @on-page-size-change="pageSizeChange"/>
      </div>
    </div>

    <SimpleTable :columns="columns"
                 :table-data="NewData"
                 :sort-option="sortOption"
                 style="width: 100%"/>
  </div>
</template>
<script>
import { h } from "vue";
import { mapState } from "vuex";

import auth from "@/helpers/auth";
import actionButton from "../../components/actionButton.vue";
import dealerCell from "../../components/dealerCell.vue";
import SimpleTable from "@/components/SimpleTable.vue";
import SimplePagination from "@/components/SimplePagination.vue";

export default {
  components: {
    actionButton,
    SimpleTable,
    SimplePagination
  },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },
  data: function () {
    return {
      "sortOption": {
        "sortChange": (params) => {
          this.sortChange(params);
        },
      },
      "columns": [
        {
          "field": "id",
          "key": "a",
          "title": "ID",
          "align": "center",
        },
        {
          "field": "widget_config",
          "key": "b",
          "title": "Last date",
          "align": "center",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            const obj = JSON.parse(row.widget_config);
            return h("p", {}, (new Date(parseInt(obj.date))).toUTCString());
          }
        },
        {
          "field": "widget_config",
          "key": "c",
          "title": "Dealership info",
          "align": "center",
          "renderBodyCell": this.renderRowIndex
        },
        {
          "field": "widget_config",
          "key": "d",
          "title": "Referer",
          "align": "center",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            const obj = JSON.parse(row.widget_config);
            return h("div", {}, h("p", {}, obj.referer));
          }
        }
      ],
      // page index
      "pageIndex": 1,
      // page size
      "pageSize": 10,
      "maintable": [],
      "searchValue": '',
    };
  },

  computed: {
    ...mapState({
      listcfgs: (state) => state.wrongcfgevents.all,
      meta: (state) => state.wrongcfgevents.meta,
      dealerships: (state) => state.dealerships.all
    }),
    database: {
      set: function (val) {
        this.maintable = val;
        // If necessary, also copy val into an external variable here
      },
      get: function () {
        if (this.maintable.length === 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.maintable = this.listcfgs;
        }
        return this.maintable;
      }
    },
    NewData() {
      return this.database;
    }
  },

  mounted() {
    this.$store.dispatch("fetchWrongCfgEvents");
    this.database = this.listcfgs;
  },
  methods: {
    initialFetch() {
      this.$store.dispatch("fetchWrongCfgEvents").then(() => {
        this.database = [];
        this.$nextTick(() => {
          this.database = this.listcfgs;
        });
      });
    },

    renderRowIndex({row, column, rowIndex}) {
      const obj = JSON.parse(row.widget_config);
      let dealership;
      try {
        dealership = JSON.parse(obj.dealership);
      } catch (e) {
        dealership = obj.dealership;
      }
      return h(dealerCell, { dealership: dealership });
    },

    // page number changes
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.$store.commit("setCfgCurrentPage", pageIndex);
      this.$store.dispatch("fetchWrongCfgEvents").then(() => {
        this.maintable = [];
      });
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.$store.commit("setCfgPageSize", pageSize);
      this.$store.dispatch("fetchWrongCfgEvents").then(() => {
        this.maintable = [];
      });
    }
  }
};
</script>
<style>
div.container {
  display: flex;
}

div.upper_header {
  padding-left: 90px;
  margin-bottom: 20px;
}

div.fixed {
  width: 500px;
  display: flex;
  float: left;
  padding-top: 12px;
  height: 60px;
}

div.flex-item {
  flex-grow: 1;
  float: right;
  text-align: end;
}

.upper_button {
  margin-left: 12px;
  height: 32px;
  padding-top: 3px;
}
</style>
